module.exports = __webpack_public_path__ + "media/images/category/dummy/bag05-d8d9a29868f3e1db1f03b704d9469758.jpg";